export const CustomersStatus = {
  churned: 'Churned',
} as const;
export type CustomersStatus = (typeof CustomersStatus)[keyof typeof CustomersStatus];

export interface Plan {
  name: string;
}

export class Customers {
  public name: string;
  public status: CustomersStatus;
  public plan: string;

  constructor(name: string, status: CustomersStatus, plan: string) {
    this.name = name;
    this.status = status;
    this.plan = plan;
  }
}
